/**
 * Created by Owlz on 24/10/2017.
 */

"use strict";

import Sprite3D from "./Sprite3D";
import Shake    from "./Shake";

/**
 * @class
 */
export default class Betty extends Sprite3D {
    /**
     * @param texName {String} - texture name
     * @param holder {*|PIXI.projection.Container2d} - optional holder to add to
     * @param scoreManager {ScoreManager}
     * @param cb {function}
     */
    constructor(texName, holder, scoreManager, cb) {
        super("", holder);

        /**
         * @type {Function}
         */
        this.cb = cb;

        /**
         * @type {number}
         * @private
         */
        this._moveSpeed = Common.config.path_speed;

        /**
         * @type {number}
         * @private
         */
        this._dx = 0;

        /**
         * @type {number}
         * @private
         */
        this._dy = 0;

        /**
         * @type {Array}
         * @private
         */
        this._path = [];

        /**
         * @type {PIXI.Point}
         * @private
         */
        this._target = null;

        /**
         * @type {boolean}
         * @private
         */
        this._sleep = true;

        /**
         * @type {boolean}
         * @private
         */
        this._isReal = false;

        /**
         * @type {ScoreManager}
         * @private
         */
        this._scoreManager = scoreManager;

        /**
         * @type {boolean}
         * @private
         */
        this._pause = false;

        /**
         * @type {*|PIXI.projection.Container2d}
         * @private
         */
        this._container3D = holder;

        /**
         * @type {Array}
         * @private
         */
        this._projectiles = [];

        /**
         * @type {number}
         * @private
         */
        this._projectileSpeed = Common.config.projectile_speed;

        /**
         * @type {Array}
         * @private
         */
        this._testPath = null;

        /**
         * @type {number}
         * @private
         */
        this._time = 0;

        /**
         * @type {number}
         * @public
         */
        this.pathId = -1;

        /**
         * @type {null|PIXI.particles.Emitter}
         * @private
         */
        this._emitter = null;

        /**
         * @type {null|PIXI.particles.Emitter}
         * @private
         */
        this._emitter2 = null;

        /**
         * @type {null|PIXI.Container}
         * @private
         */
        this._particleHolder = null;

        /**
         * @type {Array}
         * @private
         */
        this._explodingPieces = [];

        /**
         * @type {boolean}
         * @private
         */
        this._isReal = false;

        /**
         * @type {null}
         * @private
         */
        this._shadow = null;

        /**
         * @type {number}
         * @private
         */
        this._particleStartY = -1;

        /**
         * @type {null}
         * @private
         */
        this._targetVelocity = null;

        /**
         * @type {null}
         * @private
         */
        this._velocity = new PIXI.Point();

        /**
         * @type {number}
         * @private
         */
        this._fireDelay = 3;

        /**
         * @type {number}
         * @private
         */
        this._fireTime = 0;

        /**
         * @type {Shake}
         * @private
         */
        this._myShake = new Shake();

    }

    /**
     * @public
     */
    init() {


        this.view = P3.createSpine("betty", "idle1");
        this.view.anchor = new PIXI.Point(0.5, 1);
        this.view.scale.set(0.5);
        this.addChild(this.view);

        if (this._isReal) {
            this.view.skeleton.setSkinByName("good");
        } else {
            this.view.skeleton.setSkinByName("bad");
        }
        this.view.skeleton.setSlotsToSetupPose();
        this.view.y = -125;

        this.view.visible = false;
        this.visible = false;

        this._myShake.setTarget(this.view);
        this._myShake.maxOffsetX = 175;//big ol shake
        this._myShake.maxOffsetY = 175;

        let hitArea = P3.createSprite(PIXI.Texture.EMPTY, this._view);
        hitArea.width = 625;//old value, 325
        hitArea.height = 625;
        hitArea.anchor.set(0.5);

        hitArea.interactive = true;
        hitArea.pointerdown = hitArea.touchstart = this._inputdown.bind(this);

        const shadow = P3.createSprite(Common.shadowTexture, this);
        shadow.y = -this._view.y - 150;
        shadow.scale.set(1.25);
        shadow.alpha = 0.15;
        shadow.visible = false;

        this._shadow = shadow;
        this._shadowStartScale = shadow.scale.x;
        this._shadowStartPos = new PIXI.Point(shadow.x, shadow.y);
        this._viewStartPos = new PIXI.Point(this.view.x, this.view.y);
    }

    startTweens() {

        if (!this._viewTween) {
            this._viewTween = TweenMax.to(this._view, 1, {
                y: this._view.y - 85,
                yoyo: true,
                repeat: -1,
                ease: Power1.easeInOut
            });
        }

        if (!this._shadScaleTween) {
            this._shadScaleTween = TweenMax.to(this._shadow.scale, 1, {
                x: 1,
                y: 1,
                yoyo: true,
                repeat: -1,
                ease: Power1.easeInOut
            });
        }

        if (!this._shadAlphaTween) {
            this._shadAlphaTween = TweenMax.to(this._shadow, 1, {
                alpha: 0.1,
                yoyo: true,
                repeat: -1,
                ease: Power1.easeInOut
            });
        }

    }

    endTweens() {

        if (this._viewTween) {
            this._viewTween.kill();
            this._viewTween = null;
        }

        if (this._partTween) {
            this._partTween.kill();
            this._partTween = null;
        }

        if (this._shadScaleTween) {
            this._shadScaleTween.kill();
            this._shadScaleTween = null;
        }

        if (this._shadAlphaTween) {
            this._shadAlphaTween.kill();
            this._shadAlphaTween = null;
        }
    }

    /**
     * @public
     */
    update() {

        this.view.update(deltaTime);

        this._myShake.update(deltaTime);

        //--fire timer--//
        if (!this._isReal) {
            this._fireTime += deltaTime;
            if (this._fireTime > this._fireDelay) {
                this._fireTime = 0;
                if (Math.random() < 0.25) {//small chance to shoot projectile
                    this._fireProjectile();
                }
            }
        }

        //--update projectile spine animation--//
        const len = this._projectiles.length;
        for (let i = 0; i < len; i++) {
            this._projectiles[i].view.update(P3.deltaTime)
        }

        //--update emitters--//
        if (!this._isReal) {
            this._emitter.update(P3.deltaTime);
            this._emitter2.update(P3.deltaTime);

            this._particleHolder.x = this._view.x;
            this._particleHolder.y = this._view.y - 15;
        }

        for (let i = 0; i < this._explodingPieces.length; i++) {
            if (!this._explodingPieces[i]) {
                continue;
            }
            this._explodingPieces[i].x += this._explodingPieces[i].dx * P3.deltaTime;
            this._explodingPieces[i].y += this._explodingPieces[i].dy * P3.deltaTime;
        }

        if (!this._target || this._sleep || this._pause || !this._view.visible) return;

        let dist = Common.distance(this.x, this.y, this._target.x, this._target.y);
        if (dist === 0) dist = 1; //ovoid NaN on divide by zero

        this._dx = (this._target.x - this.x) / dist;//get each component of our direction vector and normalise with the length
        this._dy = (this._target.y - this.y) / dist;

        this._targetVelocity = new PIXI.Point(this._dx * this._moveSpeed, this._dy * this._moveSpeed);

        const force = 15;

        if (this._velocity.x < this._targetVelocity.x) {
            this._velocity.x += force;
        } else if (this._velocity.x > this._targetVelocity.x) {
            this._velocity.x -= force;
        }

        if (this._velocity.y < this._targetVelocity.y) {
            this._velocity.y += force;
        } else if (this._velocity.y > this._targetVelocity.y) {
            this._velocity.y -= force;
        }

        this.x += this._velocity.x * P3.deltaTime;//scale by move speed and multiply by dt before addition
        this.y += this._velocity.y * P3.deltaTime;

        if (dist < 10) {
            this._path.pop();
            this.setTarget();
        }

    }

    /**
     * @public
     */
    test() {
        console.log(this._path[this._path.length - 1]);
        let node = this._path[this._path.length - 1];

        if (!node) {
            console.warn("testing path finished");
            return;
        }

        TweenMax.to(this, 5, {
            x: node.x, y: node.y,
            ease: Power0.easeNone,
            onComplete: () => {
                this._path.pop();
                this.test();
            }
        });
    }

    /**
     * @public
     */
    jumpToTarget() {
        if (!this._target) return;
        this.x = this._target.x;
        this.y = this._target.y;
    }

    /**
     * @public
     */
    setTarget() {
        if (this._path.length > 0) {
            this._target = this._path[this._path.length - 1];
            if (Math.random() < 0.05) {//small chance to pause for a bit
                this._pause = true;
                this._velocity = new PIXI.Point();
                delay(()=> {
                    this._pause = false;
                }, 1, this);
            }
        } else {
            this._pathComplete();
        }
    }

    /**
     * @public
     * @param pause {boolean}
     */
    pauseProjectiles(pause) {
        const len = this._projectiles.length;
        for (let i = 0; i < len; i++) {
            if (pause) {
                this._projectiles[i].tweens[0].resume();
                this._projectiles[i].tweens[1].resume();
            } else {
                this._projectiles[i].tweens[0].pause();
                this._projectiles[i].tweens[1].pause();
            }
        }
    }

    /**
     * @public
     */
    initParticles() {

        this._particleHolder = new PIXI.Container();
        this._particleHolder.scale.set(0.5);
        this._particleHolder.y -= (this.view.height * 0.5 * 0.65) + 35;

        this._particleStartY = this._particleHolder.y;

        this.addChild(this._particleHolder, this._view);

        this._emitter = P3.createParticles(this._particleHolder, "part_virus_1", {
            name: "part_virus_2_",
            count: 1
        }, null, true);
        this._emitter.emit = false;

        this._emitter2 = P3.createParticles(this._particleHolder, "part_virus_2", {
            name: "part_virus_",
            count: 3
        }, null, true);
        this._emitter2.emit = false;
    }

    wakeUp() {

        this.dieing = false;
        this.visible = true;

        this.setTarget();
        this.jumpToTarget();

        //--start an alpha tween to blend them coming in--//
        this.alpha = 0;
        TweenMax.to(this, 0.5, {alpha: 1});

        this._sleep = false;
        this._view.visible = this._shadow.visible = true;
        this._pause = false;
        if (!this._isReal) {
            this._emitter.emit = true;
            this._emitter2.emit = true;
            this._particleHolder.visible = true;
        }
        this.startTweens();
    }

    goToSleep() {
        this._view.visible = this._shadow.visible = false;
        this._sleep = true;
        if (!this._isReal) {
            this._emitter.emit = false;
            this._emitter2.emit = false;
        }
    }

    /**
     * @private
     */
    _pathComplete() {

        this.goToSleep();

        this.endTweens();

        this._shadow.alpha = 0.15;
        this._shadow.scale.x = this._shadow.scale.y = this._shadowStartScale;
        this._shadow.position = new PIXI.Point(this._shadowStartPos.x, this._shadowStartPos.y);
        this._view.position = new PIXI.Point(this._viewStartPos.x, this._viewStartPos.y);

        if (this._particleHolder) {
            this._particleHolder.y = this._particleStartY;
        }

        this._target = null;
        this.view.interactive = true;

        const index = Common.activePathIds.indexOf(this.pathId);
        Common.activePathIds.splice(index, 1);

    }

    /**
     * @param event
     * @private
     */
    _inputdown(event) {

        if (this._sleep || !this._scoreManager.gotBullets() || this.dieing || this.immortal || Common.paused) return;

        this._playLaserSound();

        this.dieing = true;

        this.view.interactive = false;//turn interaction off until the enemy is hidden / sleeping

        if (this._isReal) {
            this._scoreManager.resetMultiplier();
            this._scoreManager.hitPlayer();
        } else {
            this._scoreManager.addMultiplier();
            this._scoreManager.addScore();
            this._view.texture = Common.assets.texture("betty_bad_hit");
            this._particleHolder.visible = false;
        }

        this.view.tint = this._tint;

        this._scoreManager.useBullet();

        this._shake(this._view, ()=> {
            if (!this._isReal) this._createAnimatedScore();
            this._pathComplete();
            this._explode();
        });

        this._playLaserSound();
        this._playHitSound();

        //--create particle effect--//
        const assets = Common.assets;
        const textures = assets.texture("part_hit_shot_1");
        const config = assets.json("part_hit_shot");
        const emitter = new PIXI.particles.Emitter(this, textures, config);

        const local = event.data.getLocalPosition(this);
        emitter.updateOwnerPos(local.x, local.y);

        emitter.playOnce(()=> {
            this.removeChild(emitter);
            emitter.destroy();
        });

        if (this.tutorialBetty) {
            this.tutCB();
        }
    }

    tutCB() {
        //override
    }

    _createAnimatedScore() {
        const view = createText("" + this._scoreManager.getHitValue(), {
            size: 95,
            fill: 0xffffff,
            stroke: "black",
            strokeWidth: 5
        });
        view.y = -175;
        this.addChild(view);
        TweenMax.to(view, 0.25, {
            y: view.y - 200,
            ease: Power2.easeOut,
            onComplete: ()=> {
                TweenMax.to(view, 0.15, {
                    alpha: 0,
                    y: -P3.View.height,
                    ease: Power2.easeIn,
                    delay: 0.2,
                    onComplete: ()=> {
                        this.removeChild(view);
                        view.destroy();
                    }
                });
            }
        });
    }

    /**
     * @private
     */
    _fireProjectile() {

        if (this.y > -P3.View.height || this.x < 0 || this.x > P3.View.width || this._sleep) return;//don't fire if betty is close to screen or edges

        const projectile = new Sprite3D();
        projectile.position.set(this.x, this.y);
        projectile.view = P3.createSpine("projectile_1", "animation");
        projectile.view.autoUpdate = false;
        projectile.addChild(projectile.view);

        projectile.view.y = this._view.y - 75;

        const dist = Common.distance(projectile.x, projectile.y, 0, 0);//distance to zero is just as good really
        const vel = this._projectileSpeed;
        const t = dist / vel;

        const tw1 = TweenMax.to(projectile, t, {
            x: P3.View.width * 0.5 + P3.math.randomInt(-250, 250),
            y: 0,
            ease: Power0.easeNone,
            onComplete: ()=> {

                //--add a decal in this position--//
                const decal = P3.createSprite("hit_decal", Common.world);
                decal.anchor.set(0.5);

                const global = projectile.view.toGlobal(Common.world);
                decal.x = /*(Common.STAGE_WIDTH - P3.View.width) * 0.5 + */global.x - P3.View.width * 0.5;
                decal.y = global.y - P3.View.height * 0.5;

                decal.alpha = 0.75;

                TweenMax.to(decal, 0.5, {
                    alpha: 0,
                    delay: 0.5,
                    onComplete: ()=> {
                        decal.destroy();
                    }
                });

                TweenMax.killTweensOf(projectile.view);
                TweenMax.killTweensOf(projectile);
                this._container3D.removeChild(projectile);
                projectile.destroy();
                const index = this._projectiles.indexOf(projectile);
                this._projectiles.splice(index, 1);
                this._scoreManager.hitPlayer();
            }
        });

        let targ = P3.math.randomInt(-350, -450);

        const tw2 = TweenMax.to(projectile.view, t * 0.5, {
            y: projectile.view.y - 550,
            ease: Power1.easeOut
        });

        const tw3 = TweenMax.to(projectile.view, t * 0.5, {
            y: targ,
            ease: Power1.easeIn,
            delay: t * 0.5
        });

        projectile.tweens = [tw1, tw2, tw3];

        this._container3D.addChild(projectile);
        this._projectiles.push(projectile);

        projectile.interactive = true;
        projectile.mousedown = projectile.touchstart = this._projectileDown.bind(this);

        Common.audio.playSound("sfx_enemyfire");

    }

    /**
     * @param event
     * @private
     */
    _projectileDown(event) {

        if (!this._scoreManager.gotBullets()) {
            return;
        } else {
            this._scoreManager.useBullet();
        }

        this._playLaserSound();

        const projectile = event.target;
        if (projectile.deflected) return;

        TweenMax.killTweensOf(projectile);
        projectile.deflected = true;

        TweenMax.to(projectile, 0.25, {
            x: P3.View.width * 0.5 + P3.math.randomInt(-P3.View.width, P3.View.width),
            y: -P3.View.height * 8,//double full depth
            ease: Power0.easeNone,
            onComplete: ()=> {
                TweenMax.killTweensOf(projectile.view);
                TweenMax.killTweensOf(projectile);
                this._container3D.removeChild(projectile);
                projectile.destroy();
                const index = this._projectiles.indexOf(projectile);
                this._projectiles.splice(index, 1);
            }
        });
        TweenMax.to(projectile.view, 0.25, {
            y: P3.math.randomInt(-500, -800),
            ease: Power0.easeNone
        });

        this._playLaserSound();

        Common.audio.playSound("sfx_deflectshot");
    }

    /**
     * @param element
     * @param cb
     * @private
     */
    _shake(element, cb) {
        //changed to use my new shake class
        this._myShake.onShakeEnd = cb;
        this._myShake.trauma = 0.25;

        /*
         const t = 0.05;
         TweenMax.to(element, t, {
         x: element.x - 15,
         y: element.y - 15,
         ease: Quad.easeInOut
         });
         TweenMax.to(element, t, {
         repeat: 4,
         x: element.x + 15,
         y: element.y + 15,
         yoyo: true,
         delay: 0.1,
         ease: Quad.easeInOut
         });
         TweenMax.to(element, t, {
         x: element.x,
         y: element.y,
         delay: t * 4,
         onComplete: cb.bind(this)
         });
         */
    }

    /**
     * @private
     */
    _playLaserSound() {
        Common.audio.playSound([
            "sfx_firelaser1",
            "sfx_firelaser2",
            "sfx_firelaser3"
        ]);
    }

    /**
     * @private
     */
    _playHitSound() {
        if (!this._isReal) {
            Common.audio.playSound("sfx_enemyhit");
        } else {
            Common.audio.playSound("sfx_realwendyhit");
        }
    }

    /**
     * @private
     */
    _explode() {

        let texName = "betty_bad_part_";
        if (this._isReal) {
            texName = "betty_good_part_";
        }

        const pieces = [];
        for (let i = 1; i <= 9; i++) {
            const piece = P3.createSprite(texName + i, this);
            piece.scale.set(0.65);
            piece.position.set(this.view.x, this.view.y - this.view.height * 0.5);
            piece.dx = P3.randomInt(-400, 400);
            piece.dy = P3.randomInt(-150, 0);
            piece.anchor.set(0.5);
            pieces.push(piece);
        }
        this._explodingPieces = pieces;

        delay(this._cleanupPieces.bind(this), 0.1, this);
    }

    _cleanupPieces() {
        const len = this._explodingPieces.length;
        const t = 0.5;
        for (let i = 0; i < len; i++) {
            TweenMax.to(this._explodingPieces[i], t, {
                alpha: 0,
                ease: Power0.easeNone,
                onComplete: ()=> {
                    this.removeChild(this._explodingPieces[i]);
                }
                , delay: 0.3
            });
        }
        delay(()=> {
            for (let i = 0; i < len; i++) {
                this._explodingPieces[i].destroy();
            }
            this._explodingPieces.length = 0;
        }, t + 0.4, this);
    }

    setTint() {
        /// if (this._isReal) {
        ///     this._tint = 0x37FDFC;
        ///  } else {
        ///      this._tint = 0xDD0048;
        //  }
        ///this._glowFilter = new PIXI.filters.GlowFilter(15, 0, 0, this._tint, 0.2);
    }

    //=======================//
    //====GETTERS SETTERS====//
    //=======================//

    set path(value) {
        this._path = value;
    }

    get sleep() {
        return this._sleep;
    }

    set sleep(value) {
        this._sleep = value;
    }

    set isReal(value) {
        this._isReal = value;
    }
}